import type { ThemeDefinition } from './types';

export const oceanic: ThemeDefinition = {
  id: 'oceanic',
  name: 'Oceanic',
  description: 'Teal and cyan palette with smooth gradients and a calming aesthetic',
  mode: 'light',
  tokens: {
    colorPrimary: '#0D9488',
    colorSecondary: '#06B6D4',
    colorAccent: '#10B981',
    colorSuccess: '#059669',
    colorWarning: '#D97706',
    colorError: '#E11D48',
    colorInfo: '#0891B2',
    colorBgBase: '#F0FDFA',
    colorBgContainer: '#F7FFFE',
    colorBgElevated: '#FFFFFF',
    colorBgSidebar: '#0F4C4D',
    colorText: '#134E4A',
    colorTextSecondary: '#3D7A76',
    colorTextTertiary: '#6BA3A0',
    colorBorder: '#B2DFDB',
    colorBorderSecondary: '#D4EFED',
    boxShadow: '0 1px 3px rgba(13,148,136,0.06), 0 4px 12px rgba(13,148,136,0.05)',
    boxShadowSecondary: '0 4px 16px rgba(13,148,136,0.08), 0 8px 24px rgba(13,148,136,0.06)',
    glassBlur: '18px',
    glassOpacity: '0.35',
    glassSaturation: '160%',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontFamilyHeading: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 14,
    fontSizeHeading: 20,
    borderRadius: 10,
    borderRadiusLG: 18,
    cardBorder: '#B2DFDB',
    cardShadow: '0 2px 8px rgba(13,148,136,0.06)',
  },
};
